module.exports = __webpack_public_path__ + "fonts/Lato-MediumItalic.4d295621.woff2";